import React, { useState } from 'react';
import ConsultationList from '../../doctor/ConsultationList';
import DoctorIntakePanel from '../../doctor/DoctorIntakePanel';
import { useDoctorWorkspace } from '../../doctor/doctorWorkspaceContext';

/** Consultations — direction médicale (liste professionnelle, site via barre supérieure). */
export default function HeadDoctorConsultationsPage() {
  const { workSiteId, bumpDashboardStats, portalPaths, clinicalWorkspace } = useDoctorWorkspace();
  const [intakeReloadNonce, setIntakeReloadNonce] = useState(0);

  const handleIntakeSuccess = () => {
    setIntakeReloadNonce((prev) => prev + 1);
    bumpDashboardStats();
  };

  return (
    <div className="doctor-dashboard recv-dash-pro--main hd-consult-page">
      <DoctorIntakePanel onIntakeSuccess={handleIntakeSuccess} className="mb-4" />
      <ConsultationList
        workSiteId={workSiteId}
        clinicalWorkspace={clinicalWorkspace}
        consultationRoutesBase={portalPaths.CONSULTATIONS}
        onConsultationsMutated={bumpDashboardStats}
        externalReloadNonce={intakeReloadNonce}
      />
    </div>
  );
}
